import React, { Component } from 'react';
import { Flex } from 'antd-mobile';
// 此页面为合同文案页面 尽量少写样式

class RsrushLoanContract extends Component {
  constructor(props) {
    super(props);

    this.state = {
      applicationId: '',
      loanData: {},
    }
  }
  // 初始化
  componentDidMount() {
    document.title = 'RsKash Loan Sanction Letter';
    this.initTerms();
  }

  getLoanData(key, isNum = false) {
    const { loanData } = this.state;
    if (loanData) {
      return loanData[key] || (isNum ? 0 : '--');
    }
    return isNum ? 0 : '--';
  }

  initTerms() {
    if (window.android) {
      try {
        const loan = window.android.initLoanAgreement();
        this.setState({
          loanData: loan ? JSON.parse(loan) : null,
        })
      } catch (err) {
        console.log(err);
      }
    }
  }

  render() {
    const userName = this.getLoanData('name');
    const phoneNumber = this.getLoanData('mobile');
    const localDate = this.getLoanData('currDate');
    const terms = this.getLoanData('limitDays');
    const principalAmount = this.getLoanData('principalAmount');
    const otherFee = this.getLoanData('otherFee', true);
    const paymentFee = this.getLoanData('paymentFee', true);
    const processingFees = (+paymentFee) + (+otherFee);
    const panId = this.getLoanData('panCardNumber');
    const bankName = this.getLoanData('bankName');
    const bankAccountNo = this.getLoanData('bankAccountNo');
    const IFSC = this.getLoanData('ifsc');
    const Email = this.getLoanData('email');
    const loanAmount = this.getLoanData('loanAmount');
    const repayTenure = this.getLoanData('repayTenure');
    const repayAmount = this.getLoanData('repayAmount');
    const customerId = this.getLoanData('customerId');
    const aadhaarNumber = this.getLoanData('aadhaarNumber');

    return <Flex className='doc' direction='column'>
      <Flex.Item className='body'>
        {/* <h1>Loan Agreement_Final</h1> */}
        <h2>Loan Terms and Conditions (“Agreement”)</h2>
        <h2>(Revolving Credit Facility)</h2>

        <p>In the event, (“<b>Company</b>”) agrees to grant a loan of amount as provided in MOST IMPORTANT LOAN TERMS (“Loan”) to undersigned Applicant (“Borrower”). The Borrower may apply for one or more loans by submitting the Loan Application Form (“LAF”) that are or will be governed by below mentioned terms (“Agreement”)</p>
        <p></p>
        <ol>
          <li>Borrower shall repay Loan along with interest and charges approved by the Company and provided in MOST IMPORTANT LOAN TERMS (“Payables”) in accordance with repayment schedule provided therein (“Repayment Schedule”).</li>

          <li>Company shall disburse entire/ part of Loan from its designated bank account to Borrower’s bank account provided in loan application form submitted through this platform (“Platform”).</li>

          <li>
            <h4>Company is committed to fair and transparent practices and accordingly:</h4>
            <ol>
              <li>abides by Fair Practice Code;</li>

              <li>ensures preventing inappropriate staff behavior;</li>

              <li>strives to educate Borrower on all aspects of Loan and the Agreement;</li>

              <li>allows Borrower to pre-close Loan, by paying interest and processing fee as applicable for the complete duration of the loan taken;</li>

              <li>does not resort to undue harassment in Loan recovery and/or interferes in Borrower’s affairs (unless required for recovery of Loan);</li>

              <li>Adequate grievance redress system is set up for redressal of queries. </li>

              <li>Assures that the Privacy of the Borrower will be respected at all times;</li>

              <li>does not charge penalty on delayed payment; however, in the event of any delay on re-payment of Loan along with Interest, an over-due charge will be levied on the principal amount payable for the delay period as mentioned in MOST IMPORTANT LOAN TERMS. </li>

              <li>Changes in interest rates and  charges are effected only prospectively.</li>

              <li>And / or does not collect security deposit / margin.</li>
            </ol>
          </li>

          <li>
            <h4>Borrower represents, warrants and undertakes that he/she:</h4>
            <ol>
              <li>completely understands the Agreement and is ﬁnancially and legally capable to perform his/her obligations;</li>
              <li>information and representations provided on Platform including LAF are true and he/she will immediately inform Company of any change;</li>
              <li>shall utilize Loan only for purpose mentioned in LAF and make repayment only through Company’s approved methods; and</li>
              <li>shall fully cooperate and abide by the Terms & Conditions (T&C) laid out by the Company.</li>
            </ol>
          </li>

          <li>
            <h4>Subject to law, Company may:</h4>
            <ol>
              <li>withhold and/or cancel the disbursement of Loan/its instalment upon breach of Agreement and/or law by Borrower; and/or</li>

              <li>Recall Loan without assigning any reasons, upon which Payables shall be paid by Borrower within 7 days from such recall.</li>
            </ol>
          </li>

          <li>
            <h4>Agreement’s term shall be from Effective Date to the time entire Payables is repaid to Company, unless terminated earlier upon occurrence of any Event of Default (“EOD”). EOD shall be deemed to have occurred if:</h4>
            <ol>
              <li>Borrower commits a breach or fails or neglects to perform, keep or observe any of the provisions of Agreement including failure to repay for more than 45 calendar days;</li>

              <li>Any covenant, representation, warranty of Borrower under Agreement and/or LAF are found/proved to be incomplete, false or incorrect;</li>

              <li>Borrower has an insolvency notice served on him; (ii) is declared insane; (iii) convicted of any offence; and/or</li>

              <li>an event, which in Company’s opinion, impairs Borrower’s ability to repay Payables, occurs.</li>
            </ol>
          </li>

          <li>
            <h4>Upon occurrence of any EOD, Company may: </h4>
            <ol>
              <li>terminate Agreement; and/or</li>

              <li>declare all Payables (whether due or not), immediately repayable.</li>
            </ol>
          </li>

          <li>
            <h4>If Borrower fails to make payments (as provided above) within 7 days thereof, Company may at its sole discretion:</h4>
            <ol>
              <li>require Borrower to pay liquidated damages equal to all unpaid payables; and/or</li>
              <li>exercise any other right or remedy available under law while giving a prior notice of same.</li>
            </ol>
          </li>

          <li>Borrower shall indemnify, defend and hold Company harmless from and against any loss arising out of or in relation to breach of terms of Agreement by Borrower.</li>

          <li>Agreement shall be subject to the exclusive jurisdiction of the courts of Bangalore. Complaints of Borrowers in relation to Agreement would be addressed in accordance with the Complain Redressal Mechanism.</li>

          <li>Borrower’s information shall be collected/used only in accordance with terms of Agreement, privacy policy on Platform (for use of information) and applicable law.</li>

          <li>
            <h4>Borrower understand and agrees that:</h4>
            <ol>
              <li>Company may share Borrower’s, co-borrower’s, guarantors, loan information including credit history and defaults to inter-alia its afﬁliates, RBI and such organizations as Company may deem ﬁt including for the purpose of fraud checks, submission of performance data to bureaus and self-regulatory organizations;</li>

              <li>Company may call for appropriate credit report, loan history and other information with respect to Borrower, co borrower, guarantors from Credit Bureaus, Statutory Bodies, Tax authorizes, Central Information Bureau, research Merchants and such other organizations as Company may deem ﬁt; and/or</li>

              <li>Company and RBI may publish or disclose details of Borrower upon default in payment of Payables, as they may deem ﬁt</li>

              <li>Borrower shall not hold Company liable for use of this information and/or for undertaking any such background checks and veriﬁcation.</li>
            </ol>
          </li>

          <li>Subject to law, Company may assign / delegate any or all of its rights, powers and functions under this Agreement to third party/ies. Borrower hereby provides his unqualiﬁed consent for the same.</li>

          <li>Company may modify any terms of Agreement provided it is communicated to Borrower.</li>

          <li>
            <h4>Any communication in relation to Agreement shall be at:</h4>
            <ol>
              <li>Borrower: address provided in LAF and/or on Platform; </li>

              <li>Company: Registered Ofﬁce.</li>
            </ol>
          </li>

          <li>Agreement, LAF and terms of Platform (including Borrower’s consent for use of information) shall constitute the entire agreement between parties. If any provision of this Agreement is held invalid, other provisions shall remain unaffected.</li>
        </ol>
        <h5>Name of the Borrower: [{ userName }]</h5>
        <h5>Date: [{ localDate }]</h5>
        <h5>Name of the Lender: [RsRush Pro]</h5>
        <h5>Date: [{ localDate }]</h5>

        <div className="divider">
          <span> </span>
        </div>

        {/* Loan Agreement */}
        <h2>Loan Agreement</h2>
        <p>I hereby agree and provide consent to abide by the provisions of Loan Agreement (as provided herein). I understand, agree and acknowledge that the validity and enforceability of this Loan Agreement is contingent upon approval of my Loan Application submitted through this Platform.</p>

        <p>I further agree and understand that in the event Loan Application is approved by Company, my consent (provided herein) along with submission of my Loan Application Details (on this Platform) should constitute a legally enforceable agreement between Company and I. No further action for executing and/or concluding Loan Agreement would be required by either Company or I.</p>

        <p>I understand that the Lender has adopted risk-based pricing, which is arrived by taking into account, broad parameters like the customers financial and credit profile. Further, I acknowledge and confirm that the Lender shall have the discretion to change prospectively the rate of interest and other charges applicable to the Loan.</p>
        
        <h4>Schedule of Loan Sanction Terms</h4>
        <ol className="align-ol">
          <li><label>Term</label><span className="underline">{ terms } Days</span></li>
          <li><label>Loan purpose</label><span className="underline">Personal</span></li>
          <li><label>Principal Amount</label><span className="underline">Rs.{ principalAmount }</span></li>
          <li><label>Loan Start Date</label><span className="underline">{ localDate }</span></li>
          <li>
            <label><b>Rate of Interest</b></label>
            <span className="underline"><b>33% per annum</b></span></li>
          <li>
            <label>Processing Fees (incl GST)</label>
            <span><span className="underline">Rs.{ processingFees }</span></span>
          </li>
          <li><label>Over-Due charges</label><span className="underline">2%</span></li>

          <li> Moratorium period between the grant of the loan and the due date of the repayment of the first installment: none</li>
        </ol>

        <h4>Loan Application Form</h4>
        <ol className="align-ol">
          <li><label>Name</label><span className="underline">{ userName }</span></li>
          <li><label>Proof of Identity</label><span className="underline">PAN</span></li>
          <li><label>PAN #</label><span className="underline">{ panId }</span></li>
          <li><label className="inline">Proof of Address(the last four digits of aadhaar)</label><span className="underline">{ aadhaarNumber }</span></li>
          <li><label>Phone Number</label><span className="underline">{ phoneNumber }</span></li>
          <li><label>Bank Name</label><span className="underline">{ bankName }</span></li>
          <li><label>Bank Account Number</label><span className="underline">{ bankAccountNo }</span></li>
          <li><label>IFSC</label><span className="underline">{ IFSC }</span></li>
          <li><label>Email ID</label><span className="underline">{ Email }</span></li>
        </ol>

        <h5>Name of the Borrower: [{ userName }]</h5>
        <h5>Date: [{ localDate }]</h5>

        <div className="divider">
          <span> </span>
        </div>

        <h2>APPLICANT’S UNDERTAKING</h2>

        <p>Applicant hereby agrees, represents and conﬁrms that:</p>

        <ol>
          <li>He/she understands that submission of LAF does not conﬁrm grant of Loan by the Company;</li>

          <li>Company shall decide on grant of Loan based on merits of the application at its absolute discretion;</li>

          <li>information provided in LAF is complete and accurate and he/she shall promptly inform the Company in case of any change;</li>

          <li>He/she has understood each and every term of Loan and is ﬁnancially and legally eligible to avail Loan;Loan Amount shall be disbursed to the bank account, the details of which are furnished by the applicant;</li>

          <li>Company shall have the right to exchange and share all of the Applicant’s loan information including credit history and defaults to afﬁliate organizations of inter alia Company, the Reserve Bank of India, Banks, Financial Institutions, Credit Bureaus, Statutory Bodies, Tax authorizes, Central Information Bureau, Research Merchants and such other organizations as Company may deem ﬁt. Applicant shall not hold Company liable for use of this information;</li>

          <li>The applicant shall be solely, absolutely and unconditionally liable for the repayment of all Amounts Due, from time to time, and shall make such payment notwithstanding any remainder, demand, notice sent or issued by * Service Provider in this regard;</li>

          <li>The applicant shall not, under any circumstances, withhold the payment of monies to *under these T&Cs; and have no objection in relation to any updates, messages or any other form of communication which the applicant may receive, from time to time, on the registered mobile number or email Id from * or the Service Provider.</li>

          <li>The applicant shall not have the right to assign, sell, transfer in any manner the rights and obligations under this T&Cs to any other person without the prior approval of * or Service Provider;</li>

          <li>Company reserves the right to reject the LAF and retain the form along with the photograph of Applicant;</li>

          <li>Applicant has not availed of a credit facility from any other   other than the one expressly mentioned by it in the LAF;</li>

          <li>He/she will provide Company with any additional documents and do such deeds as is required by the Company pursuant to submitting this LAF.</li>
        </ol>

        <p>I UNDERTAKE THAT I HAVE READ AND UNDERSTOOD PROVISIONS OF LAF INCLUDING DECLERATIONS, T&C AND UNDERTKAINGS MADE HEREIN AND I AGREE TO ABIDE BY THEM;THIS AGREEMENT IS GENERATED IN THE APP OF COMPANY’S SERVICE PRIVIDER(RSRUSH PRO), WHICH WILL COME INTO EFFECTIVE BY CLICKING “ACCPET” BELOW.</p>

        <h5>Name of the Borrower: { userName }</h5>
        <h5>Date:	{ localDate }</h5>

        {/* <h2>RHINOFinance Private Limited</h2>
        <h3 className="center">CIN : U67120AS1996PTC004705</h3> */}
        {/* 页眉 */}
        <header className="header divider">
          <span>CIN : U67120AS1996PTC004705</span>
        </header>

        <h2>SANCTION LETTER</h2>
        <p className="right">Date: { localDate }</p>

        <p>To, <br/>Mr.Ms. { userName }</p>
        <p><b>Subject: Loan Sanction Letter</b></p>
        <p><b>Ref: Loan Application No__{ customerId }</b></p>
        <p>Dear Sir/Ma’am</p>

        <p>This has reference to your above referred application for an_Personal_ (”Loan”) on behalf of _Rsrush Pro_(name of NBFC) and Based on the details/ documents provided by you for verification.<br/>_RsRush Pro_(name of Application) is pleased to inform you about according of ‘in principle’ sanction of an loan on the terms and conditions as mentioned below:</p>

        <ol>
          <li>Loan Amount: INR _{ loanAmount }__(in words)</li>

          <li>Rate of interest applicable to the loan would be as per the market conditions prevalent at the time of disbursement.</li>

          <li>Type of Rate of Interest: Simple</li>

          <li>Payment Mode: To be paid in name of NBFC(full name) through the link on the Mobile Application namely_RsRush Pro_(name of Application)</li>

          <li>Repayment tenure: { repayTenure }</li>

          <li>Applicable EMI: INR _{ repayAmount }_(in words)</li>

          <li>Validity of this offer: This sanction/offer letter will automatically stand withdrawn if the disbursement is not availed of within 7 (seven) working days from the date of issue of this sanction letter.</li>

          <li>Consequent to the Sanction letter and on disbursement/saction of Loan Amount the Loan Agreement be tendered.</li>

          <li>Also the Company reserves the right to cancel the Application on valid grounds before the disbursement of Loan Amount as mentioned/entitled.</li>
        </ol>

        <p>For and on the behalf of _Rsrush Pro_</p>
        <p>REG. OFFICE: R. DUTTA MARKET, 2ND FLOOR, A. T. ROAD, GUWAHATI, ASSAM, IN–781001.CORP. OFFICE :GROUND FLOOR, H-55, SEC-63, NOIDA, UTTAR PRADESH-201301.</p>
      </Flex.Item>
    </Flex>
  }
}

export default RsrushLoanContract;
